module.exports = __webpack_public_path__ + "img/img14.62d09954.png";